import { lazy } from 'react'

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (resolver : any, name = 'default') => {
    return lazy(async () => {
        const resolved = await resolver()
        return {default: resolved[name]}
    })
}